<template>
  <v-flex xs12>

    <v-alert v-if="errors.length" type="error" class="red lighten-1" dense>
      <p>
        <b>Missing required fields:</b>
        <ul>
          <li v-for="error in errors">{{ error }}</li>
        </ul>
      </p>
    </v-alert>

    <v-card color="blue-grey darken-3">
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs4>
            <v-select
              v-model="s_year"
              label="Year"
              :items="year_opt"
              required dense
            >
            </v-select>
          </v-flex>
          <v-flex xs4>
            <v-select
              v-model="s_month"
              label="Month"
              :items="month_opt"
              required dense
              item-text="month"
              item-value="id"
            >
            </v-select>
          </v-flex>
          <v-flex xs4>
            <v-select
              v-model="s_day"
              label="Day (TBA - Date Range)"
              :items="day_opt"
              item-text="day"
              item-value="id"
              required dense
            >
            </v-select>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs4>
            <v-autocomplete
              v-model="s_customer"
              label="Customer"
              :items="customer_opt"
              item-text="concat"
              item-value="id"
              multiple dense chips
            ></v-autocomplete>
          </v-flex>
          <v-flex xs4>
            <v-select
              v-model="s_region"
              label="Region"
              :items="region_opt"
              item-text="name"
              item-value="id"
              multiple dense chips
            ></v-select>
          </v-flex>
          <v-flex xs4>
            <v-autocomplete
              v-model="s_acc_manager"
              label="Account Manager"
              :items="acc_manager_opt"
              item-text="name"
              item-value="am_id"
              multiple
              dense chips
            >
            </v-autocomplete>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex class="">
            <p><kbd>Toggle for further breakdown</kbd></p>
            <v-switch class="d-inline-flex ml-2"
              v-model="switch_country"
              label="Country">
            </v-switch>
            <v-switch class="d-inline-flex ml-2"
              v-model="switch_operator"
              label="Operator">
            </v-switch>
            <v-switch class="d-inline-flex ml-2"
              v-model="switch_provider"
              label="Provider">
            </v-switch>
            <v-switch class="d-inline-flex ml-2"
              v-model="switch_platform"
              label="Platform">
            </v-switch>
            <v-switch class="d-inline-flex ml-2"
              v-model="switch_product"
              label="Product">
            </v-switch>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex class="xs3 d-flex-inline">
            <v-autocomplete
              v-if="switch_country"
              v-model="s_country"
              multiple dense chips
              :items="country_opt"
              label="Receiving Countries"
              item-text="country"
              item-value="id"
            ></v-autocomplete>
          </v-flex>
          <v-flex class="xs3 d-flex-inline">
            <v-autocomplete
              v-if="switch_operator"
              v-model="s_operator"
              multiple dense chips
              :items="operator_opt"
              label="Operators"
              item-text="operator"
              item-value="id"
            ></v-autocomplete>
          </v-flex>
          <v-flex class="xs3 d-flex-inline">
            <v-autocomplete
              v-if="switch_provider"
              v-model="s_provider"
              multiple dense chips
              :items="provider_opt"
              label="Providers"
              item-text="name"
              item-value="id"
            ></v-autocomplete>
          </v-flex>
           <v-flex class="xs3 d-flex-inline">
            <v-autocomplete
              v-if="switch_platform"
              v-model="s_platform"
              multiple dense chips
              :items="platform_opt"
              label="Platform"
              item-text="name"
              item-value="id"
              item-disabled="customDisabled"
            ></v-autocomplete>
          </v-flex>
        </v-layout>

        <v-spacer></v-spacer>
        <v-layout row>
          <v-btn class="ma-2 teal lighten-1" v-bind:disabled="!enableSubmit" small @click="submit">submit</v-btn>
          <v-btn class="ma-2 teal lighten-1" v-bind:disabled="!enableSubmit" small @click="export_excel">export excel</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="ma-2 pink lighten-1"  v-bind:disabled="!enableSubmit" small @click="clear_options">Clear Options</v-btn>
          <v-menu offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn class="ma-2 pink lighten-1"  v-bind:disabled="!enableSubmit" small slot="activator" v-on="on">Columns</v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(item, index) in headers_base" :key="index">
                <v-list-item-action
                  ><v-checkbox color="primary" v-model="item.displayed"
                /></v-list-item-action>
                <v-list-item-content>{{ item.text }}</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-layout>
      </v-card-text>

      <v-spacer></v-spacer>

      <v-card-text v-if="summary">
        <h2 class="mb-5 mt-5">Summary</h2>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" v-for="item in summary">
                  {{item.label}}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td v-for="item in summary" :key="item.name">
                  {{item.value}}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>

      <v-card-text>
        <v-layout row wrap>
            <v-flex xs4>
              <v-text-field
                  v-model="search_s"
                  append-icon="mdi-magnify"
                  label="Filter"
                  single-line
                  hide-details
                ></v-text-field>
            </v-flex>
        </v-layout>
        <br>
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :loading="loading"
          class="pt-4"
          :search.sync="search"
          sortBy="margin_usd_net"
          update: sort-desc
          >
        </v-data-table>
      </v-card-text>

    </v-card>
  </v-flex>
</template>

<script>
// Some date logic~
const moment = require('moment');

let days = [
  {id:'mon_group', day:'Entire Month (Grouped Monthly)'}, 
  {id:'day_group', day:'Entire Month (Grouped Daily)'}
];
for(let n = 1; n <= 31; n++){
  days.push({id:n, day:n});
}

let mon_str = moment.months();
let months = []
mon_str.forEach((val, index) => {
  index += 1
  let key = index < 10 ? '0'+index : index;
  months.push({id: key, month: val})
})
let tmp = moment().month()+1
let current_mon = tmp < 10 ? "0"+tmp : tmp;

export default {
  data() {
    return {
      errors: [],
      search: null,
      search_s: null,
      enableSubmit: true,
      _searchTimerId: 0,
      totalItems: 0,
      items: [],
      summary: null,
      loading: false,
      options:{ itemsPerPage: 10 },
      headers_base: [
        { text: 'Date', value: 'date', displayed: true, width: 110 },
        { text: 'Customer', value: 'customer_name', displayed: true },
        { text: 'Region', value: 'region_id', displayed: false },
        { text: 'Country', value: 'country', displayed: true },
        { text: 'Acc Manager', value: 'am_name', displayed: true },
        { text: 'Transactions', value: 'qty', displayed: true },
        { text: 'Cost AT', value: 'airtime_cost_usd', displayed: true },
        { text: 'Cost G&S', value: 'goods_and_services_cost_usd', displayed: true },
        { text: 'Cost Nexus', value: 'nexus_cost_usd', displayed: true },
        { text: 'Cost USD', value: 'cost_usd', displayed: true },
        { text: 'Revenue AT', value: 'airtime_revenue_usd', displayed: true },
        { text: 'Revenue G&S', value: 'goods_and_services_revenue_usd', displayed: true },
        { text: 'Revenue Nexus', value: 'nexus_revenue_usd', displayed: true },
        { text: 'Revenue USD', value: 'revenue_usd', displayed: true },
        { text: 'Margin AT', value: 'airtime_margin_usd', displayed: true },
        { text: 'Margin G&S', value: 'goods_and_services_margin_usd', displayed: true },
        { text: 'Margin Nexus', value: 'nexus_margin_usd', displayed: true },
        { text: 'Margin USD', value: 'margin_usd', displayed: true },
        { text: 'Margin USD Adj', value: 'margin_usd_adj', displayed: true },
        { text: 'Margin USD Net', value: 'margin_usd_net', displayed: true },
        { text: 'Margin %',value: 'margin_percentage', displayed: true }
      ],
      // Options
      year_opt: [moment().year(), moment().year()-1, moment().year()-2],
      month_opt: months,
      day_opt: days,
      customer_opt: [],
      region_opt: [],
      acc_manager_opt: [],
      country_opt: [],
      operator_opt: [],
      provider_opt: [],
      // Models
      s_year: 2020,
      s_month: current_mon,
      s_day: '',
      s_customer: '',
      s_region: '',
      s_acc_manager: '',
      s_country: '',
      s_operator: '',
      s_provider: '',
      s_platform: '',
      switch_country: false,
      switch_operator: false,
      switch_provider: false,
      switch_product: false,
      switch_platform: false
    }
  },
  computed: {
    headers() {
      return this.headers_base.filter(p => p.displayed);
    },
    displayedHeaders() {
      return this.headers.map(h => h.value);
    }
  },
  watch: {
    search_s: function(a,b){
      this.loading = true;
      this.debouncedSearch();
    },
    switch_country: function(a,b){ if(!a){ this.s_country = '';} },
    switch_operator: function(a) { if(!a){ this.s_operator = '';} },
    switch_provider: function(a) { if(!a){ this.s_provider = '';} },
    switch_platform: function(a) { if(!a){ this.s_platform = '';} }
  },
  created: async function () {
    this.customer_opt = await this.getOptions('/api/customer_list')
    this.region_opt = await this.getOptions('/api/region_list')
    this.acc_manager_opt = await this.getOptions('/api/accmanager_list')
    this.country_opt = await this.getOptions('/api/country_list')
    this.operator_opt = await this.getOptions('/api/operator_list')
    this.provider_opt = await this.getOptions('/api/provider_list')
    this.platform_opt = [
      {id: '' , name :'ALL', customDisabled:true},
      {id:'AIRTIME', name: 'AIRTIME'}, 
      {id:'GOODS_AND_SERVICES', name:'GOODS_AND_SERVICES'}, 
      {id:'NEXUS', name:'NEXUS'}
    ];
    this.debouncedSearch = this._.debounce(this.deb, 700)
  },
  methods: {
    deb() {
      this.search = this.search_s;
      this.loading = false;
    },
    clear_options() {
      this.s_year = 2020
      this.s_month = current_mon
      this.s_day = ''
      this.s_customer = ''
      this.s_region = ''
      this.s_acc_manager = ''
      this.s_country = ''
      this.s_operator = ''
      this.s_provider = ''
      this.s_platform = ''
      this.switch_country = false
      this.switch_operator = false
      this.switch_provider = false
      this.switch_product = false
      this.switch_platform = false
    },
    isDisplayed(field) {
      return this.displayedHeaders.includes(field);
    },
    async getOptions(in_url) {
      const params = {};
      return new Promise((resolve, reject) => {
        this.$http.get(in_url, params).then(res => {
          resolve(res.data.list);
        }, rejection => {
          reject(rejection)
        });
      });
    },
    getData(submitAct) {
      this.getDataFromApi(submitAct).then(data => {
        if (submitAct === 'export_excel') return;

        this.items = data.data;
        this.summary = data.summary;
      });
    },
    async getDataFromApi(submitAct) {
      this.loading = true;
      return new Promise(resolve => {
        const url = '/api/stats/traffic_details';
        let query = {
                year: this.s_year,
                month: this.s_month,
                day: this.s_day,
                customer: this.s_customer,
                region: this.s_region,
                acc_manager: this.s_acc_manager,
                country: this.s_country,
                operator: this.s_operator,
                provider: this.s_provider,
                platform: this.s_platform,
                breakdown_country: this.switch_country ? 1:0,
                breakdown_operator: this.switch_operator ? 1:0,
                breakdown_provider: this.switch_provider ? 1:0,
                breakdown_product: this.switch_product ? 1:0
              };
        let getParams = {'data': JSON.stringify(query)};
        let params = query;

        this.$router.replace({name: 'traffic_details', 'query': getParams});

        if (submitAct === 'export_excel') {
          params.is_export = 1;
          params.headers = this.displayedHeaders.join(',');
          this.$http
            .post(url, query, { responseType: 'arraybuffer' })
            .then(res => {
              this.loading = false;
              this.downloadFile(res, 'traffic_details');
            });
        } else {
          this.$http.post(url, query).then(res => {
            this.loading = false;
            this.enableSubmit = true;
            resolve(res.data);
          }, rejection => {
            console.log(rejection)
            this.enableSubmit = true;
            this.loading = false;
          });
        }        
      });
    },
    checkForm(){
      this.errors = [];
      if(this.s_year != '' && this.s_month != '' && this.s_day != ''){
        return true;
      }
      if(this.s_year == ''){ this.errors.push('Year') }
      if(this.s_month == ''){ this.errors.push('Month') }
      if(this.s_day == ''){ this.errors.push('Day') }
      // this.$store.commit('DISPLAY_ERROR', 'Missing required fields!');
    },
    submit() {
      if(this.checkForm()){
        this.enableSubmit = false;
        this.getData('submit');
      }
    },
    export_excel() {
      if(this.checkForm()){
        this.getData('export_excel');
      }
    },
    downloadFile(res, filename) {
      const newBlob = new Blob([res.data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      const link = document.createElement('a');
      link.href = data;
      link.download = `${filename}.xlsx`;
      link.click();
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    },
  },
};
</script>
<style scoped>
>>> th {
  vertical-align: top;
}
</style>
